import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { UserService } from 'src/app/core/services/user.service';
import { AuthorizerUsers, User } from '../../model/user.model';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { RequestType } from '../../model/requestType.enum';
import { OrderService } from 'src/app/core/services/order.service';
import { ApproversTypes } from '../../model/approversTypes.enum';
import { CommonModule } from '@angular/common';
import { I18NextModule } from 'angular-i18next';
import { MatSelectModule } from '@angular/material/select';
import { FeedbackModalComponent } from '../feedback-modal/feedback-modal.component';
import { MatDialog } from '@angular/material/dialog';
import i18next from 'i18next';
import { Translate } from '../../utils/translate';
import { map } from 'rxjs';
import {
  MatAutocompleteModule,
  MatAutocompleteSelectedEvent
} from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { StorageService } from 'src/app/core/storage/storage.service';

@Component({
  standalone: true,
  selector: 'app-approvers',
  templateUrl: './approvers.component.html',
  styleUrls: ['./approvers.component.scss'],
  imports: [
    CommonModule,
    I18NextModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatInputModule
  ]
})
export class ApproversComponent implements OnInit, OnChanges {
  @Input() type?: string;
  @Input() controller?: AuthorizerUsers;
  @Input() authorizer?: AuthorizerUsers;
  @Input() requestStatus?: string;
  @Input() requestNumber?: string;
  @Input() isModify?: boolean;
  @Input() isDetail!: boolean;
  @Input() loanType?: string;
  @Input() extraData: any;
  @Input() moreThan14days = false;
  @Input() extendTransfer = false;

  @Output() selectionAuthorizers = new EventEmitter<{
    controller: AuthorizerUsers;
    authorizer: AuthorizerUsers;
  }>();

  @Output() showApprovers = new EventEmitter<{
    showController: boolean;
    showAuthorizer: boolean;
  }>();

  authorizers: AuthorizerUsers[] = [];
  controllers: AuthorizerUsers[] = [];
  authorizerControl: FormControl;
  controllerControl: FormControl;
  showController = false;
  showAuthorizer = false;
  controllerError = false;
  authorizerError = false;
  errorAuthorizers = false;
  requestTypeEnum = RequestType;
  selectAuthorizer: AuthorizerUsers = {
    id: '',
    fullName: ''
  };
  selectController: AuthorizerUsers = {
    id: '',
    fullName: ''
  };
  filteredControllers: AuthorizerUsers[] = [];
  filteredAuthorizers: AuthorizerUsers[] = [];
  notModifyController = false;
  user!: User;

  constructor(
    private userService: UserService,
    private orderService: OrderService,
    public dialog: MatDialog,
    public translate: Translate,
    private storageService: StorageService
  ) {
    this.authorizerControl = new FormControl(null, [Validators.required]);
    this.controllerControl = new FormControl(null, [Validators.required]);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      (!!changes['moreThan14days'] || !!changes['loanType']) &&
      (this.type === RequestType.loan || this.type === 'LONG_DURATION')
    ) {
      if (this.moreThan14days) {
        this.showAuthorizer = true;
        this.showController = true;
      } else {
        this.showAuthorizer = true;
        this.showController = false;
      }
      this.checkGetApprovers();
      this.emitShowApprovers();
    }
  }

  ngOnInit(): void {
    if (this.storageService.get('config')) {
      this.user = this.storageService.get('config');
    }
    this.selectAuthorizer = {
      id: '',
      fullName: ''
    };
    this.selectController = {
      id: '',
      fullName: ''
    };
    if (
      this.type === RequestType.generalServices ||
      this.type === RequestType.didactic ||
      this.type === RequestType.innerRoute
    ) {
      this.showController = true;
      this.showAuthorizer = true;
    } else if (
      this.type === RequestType.dotArr ||
      this.type === RequestType.campaigns ||
      this.type === RequestType.transfers ||
      this.type === RequestType.proyect ||
      this.type === RequestType.function
    ) {
      this.showAuthorizer = false;
      this.showController = true;
    } else if (
      this.type === RequestType.loan ||
      this.type === RequestType.redPlates
    ) {
      this.showAuthorizer = true;
      this.showController = false;
    }

    if (this.isModify) {
      if (this.user.nis === this.controller?.id) {
        this.notModifyController = true;
        this.selectController = this.controller;
      } else {
        this.notModifyController = false;
      }
      this.onChangeApprovers();
    }

    this.checkGetApprovers();
    this.emitShowApprovers();

    this.controllerControl.valueChanges
      .pipe(map((value) => this.filterCont(value || '')))
      .subscribe({
        next: (filtered) => {
          this.filteredControllers = filtered;
          this.emitSelectionChange();
        },
        error: (err) => console.error('Error en valueChanges:', err)
      });

    this.authorizerControl.valueChanges
      .pipe(map((value) => this.filterAuth(value || '')))
      .subscribe({
        next: (filtered) => {
          this.filteredAuthorizers = filtered;
          this.emitSelectionChange();
        },
        error: (err) => console.error('Error en valueChanges:', err)
      });
  }

  private filterCont(value: string | AuthorizerUsers): AuthorizerUsers[] {
    const filterValue =
      typeof value === 'string'
        ? value.toLowerCase()
        : value?.fullName?.toLowerCase() || '';
    const filtered = this.controllers.filter((controller) =>
      controller.fullName.toLowerCase().includes(filterValue)
    );

    if (filtered.length === 0) {
      this.controllerControl.setErrors({ invalid: true });
      this.selectController = {
        id: '',
        fullName: ''
      };
    } else if (!value) {
      this.selectController = {
        id: '',
        fullName: ''
      };
    } else {
      this.controllerControl.setErrors(null);
    }

    return filtered;
  }

  private filterAuth(value: string | AuthorizerUsers): AuthorizerUsers[] {
    const filterValue =
      typeof value === 'string'
        ? value.toLowerCase()
        : value?.fullName?.toLowerCase() || '';
    const filtered = this.authorizers.filter((authorizer) =>
      authorizer.fullName.toLowerCase().includes(filterValue)
    );

    if (filtered.length === 0) {
      this.authorizerControl.setErrors({ invalid: true });
      this.selectAuthorizer = {
        id: '',
        fullName: ''
      };
    } else if (!value) {
      this.selectAuthorizer = {
        id: '',
        fullName: ''
      };
    } else {
      this.authorizerControl.setErrors(null);
    }

    return filtered;
  }

  checkGetApprovers() {
    if (this.showAuthorizer === true && this.showController === true) {
      this.getAuthorizeUsers(ApproversTypes.CNT);
      this.getAuthorizeUsers(ApproversTypes.DLA);
    } else if (this.showAuthorizer === false && this.showController === true) {
      this.getAuthorizeUsers(ApproversTypes.CNT);
    } else if (this.showAuthorizer === true && this.showController === false) {
      this.getAuthorizeUsers(ApproversTypes.DLA);
    }
  }

  getAuthorizeUsers(type: string) {
    let notLoanType = false;
    if (this.type === RequestType.loan && this.loanType) {
      this.type = this.translate.translateLoanTypes(this.loanType!);
    } else if (this.type === RequestType.loan && !this.loanType) {
      notLoanType = true;
    }

    if (!notLoanType) {
      this.userService.getAuthorizeUsers(type, this.type!).subscribe({
        next: (data: AuthorizerUsers[]) => {
          if (type === ApproversTypes.CNT) {
            this.controllers = data;
            this.filteredControllers = this.controllers;
          } else {
            this.authorizers = data;
            this.filteredAuthorizers = this.authorizers;
          }
          if (this.isModify) {
            this.onChangeApprovers();
          }
        },
        error: (error) => {
          console.error('Error fetching authorizers:', error);
        },
        complete: () => {
          console.log('Fetch complete');
        }
      });
    }
  }

  onControllerSelectionChange(event: MatAutocompleteSelectedEvent): void {
    this.selectController = event.option.value;
    this.controllerControl.setValue(this.selectController.fullName);
    this.emitSelectionChange();
  }

  onAuthorizerSelectionChange(event: MatAutocompleteSelectedEvent): void {
    this.selectAuthorizer = event.option.value;
    this.authorizerControl.setValue(this.selectAuthorizer.fullName);
    this.emitSelectionChange();
  }

  emitSelectionChange(): void {
    if (
      (this.showController && this.selectController.id === '') ||
      (this.showAuthorizer && this.selectAuthorizer.id === '') ||
      (this.showController && this.controllerControl.invalid) ||
      (this.showAuthorizer && this.authorizerControl.invalid)
    ) {
      this.errorAuthorizers = true;
    } else {
      this.errorAuthorizers = false;
    }
    this.selectionAuthorizers.emit({
      controller: this.selectController,
      authorizer: this.selectAuthorizer
    });
  }

  emitShowApprovers(): void {
    this.showApprovers.emit({
      showController: this.showController,
      showAuthorizer: this.showAuthorizer
    });
  }

  onChangeApprovers() {
    if (this.controller) {
      this.showController = true;
      if (this.controllers.length > 0) {
        const searchController = this.controllers.find(
          (controller) => controller.id === this.controller!.id
        );
        if (searchController) {
          this.controllerControl.patchValue(searchController.fullName);
          this.selectController = searchController;
        } else {
          this.controllers.push(this.controller);
          this.controllerControl.patchValue(this.controller.fullName);
          this.selectController = this.controller;
        }
      }
    }
    if (this.authorizer) {
      this.showAuthorizer = true;
      if (this.authorizers.length > 0) {
        const searchAuthorizer = this.authorizers.find(
          (authorizer) => authorizer.id === this.authorizer!.id
        );
        if (searchAuthorizer) {
          this.authorizerControl.patchValue(searchAuthorizer.fullName);
          this.selectAuthorizer = searchAuthorizer;
        } else {
          this.authorizers.push(this.authorizer);
          this.authorizerControl.patchValue(this.authorizer.fullName);
          this.selectAuthorizer = this.authorizer;
        }
      }
    }
    if (
      (this.showController && this.selectController.id === '') ||
      (this.showAuthorizer && this.selectAuthorizer.id === '')
    ) {
      this.errorAuthorizers = true;
    } else {
      this.errorAuthorizers = false;
    }
    this.emitSelectionChange();
  }

  sendNewApprovers() {
    if (this.extraData.requestType === RequestType.loan && this.isModify) {
      this.sendLoanModify();
    } else {
      this.orderService
        .saveApprovers(
          this.requestNumber!,
          this.selectController.id,
          this.selectAuthorizer.id
        )
        .subscribe({
          next: () => {
            this.controller = this.selectController;
            this.authorizer = this.selectAuthorizer;
            if (this.isModify) {
              this.dialog.open(FeedbackModalComponent, {
                width: '400px',
                data: {
                  text: i18next.t('approversModified'),
                  close: true,
                  theme: 'ligth'
                }
              });
            }
          },
          error: (error) => {
            if (this.isModify) {
              this.dialog.open(FeedbackModalComponent, {
                width: '400px',
                data: {
                  text: i18next.t('approversErrorModified'),
                  close: true,
                  theme: 'ligth'
                }
              });
            } else {
              console.log('Error: ' + error);
            }
          },
          complete: () => {
            console.log('Fetch complete');
          }
        });
    }
  }

  sendLoanModify() {
    const loanDataResult = {
      deliveryDate: this.extraData.loanDataDTO.deliveryDate,
      returnDate: this.extraData.loanDataDTO.returnDate,
      reason: this.extraData.loanDataDTO.reason,
      reasonText: this.extraData.loanDataDTO.reasonObservations,
      loanQuota: this.extraData.loanDataDTO.loanQuota
        ? this.extraData.loanDataDTO.loanQuota
        : 0,
      comments: this.extraData.observations ? this.extraData.observations : '',
      carpoolCenter: this.extraData.loanDataDTO.carpoolCenter,
      driverDataDTO: {
        driverType: this.extraData.loanDataDTO.driver.type,
        externalDriverData:
          this.extraData.loanDataDTO.driver.type === 'EXTERNAL'
            ? {
                identificationDocument:
                  this.extraData.loanDataDTO.driver.externalData
                    .identificationDocument,
                fullName:
                  this.extraData.loanDataDTO.driver.externalData.fullName,
                phoneNumber:
                  this.extraData.loanDataDTO.driver.externalData.phoneNumber,
                email: this.extraData.loanDataDTO.driver.externalData.email
              }
            : null,
        internalDriverData:
          this.extraData.loanDataDTO.driver.type === 'INTERNAL'
            ? {
                nis: this.extraData.loanDataDTO.driver.userId
              }
            : null,
        driverLicense: this.extraData.loanDataDTO.driver.drivingLicense
          ? true
          : false,
        address: this.extraData.loanDataDTO.driver.address
          ? this.extraData.loanDataDTO.driver.address
          : null,
        zipCode: this.extraData.loanDataDTO.driver.zipCode
          ? this.extraData.loanDataDTO.driver.zipCode
          : null,
        city: this.extraData.loanDataDTO.driver.city
          ? this.extraData.loanDataDTO.driver.city
          : null
      },
      contactInfo: {
        phoneNumber: this.extraData.contactInfo.phoneNumber,
        email: this.extraData.contactInfo.email
      },
      controllerUserId: this.selectController ? this.selectController.id : null,
      delegatedApproverUserId: this.selectAuthorizer
        ? this.selectAuthorizer.id
        : null
    };

    this.orderService
      .modifyLoanOrder(loanDataResult, this.extraData.requestNumber)
      .subscribe({
        next: () => {
          this.dialog.open(FeedbackModalComponent, {
            width: '400px',
            data: {
              text: i18next.t('approversModified'),
              close: true,
              theme: 'ligth'
            }
          });
        },
        error: () => {
          this.dialog.open(FeedbackModalComponent, {
            width: '400px',
            data: {
              text: i18next.t('approversErrorModified'),
              close: true,
              theme: 'ligth'
            }
          });
        },
        complete: () => {
          console.log('Fetch complete');
        }
      });
  }
}
